<script>
    import Letter from "../components/Letter.svelte";
    import LanguageSelect from "../components/LanguageSelect.svelte";
    import { RingLoader } from "svelte-loading-spinners";
    import { fly } from 'svelte/transition';
    import { _ } from "svelte-i18n";
    import CommonImg from "../components/CommonImg.svelte";
    import { letterData, loadingData } from "../services/store";

    export let data1, data2, language1, language2, subTopic, commonImg,selectedLink;
</script>
<style>
    .fullHeight{
        height: fit-content;
        min-height: 100vh;
    }
</style>
<div class="container mx-auto px-1 lg:px-4  {selectedLink!='letters'?'sm:pt-16':''}"
in:fly="{{x:-100, duration: 300, delay:300 }}"
out:fly="{{x:100, duration: 300 }}"
>
    <div class="relative fullHeight flex flex-col min-w-0 break-words w-full">
        {#if data1 && data2 && language1 && language2 && subTopic}
            <!-- <div class="text-center text-2x">
                {#if subTopic}
                    <h2 class="text-xl uppercase">
                        <span>{subTopic.value}</span>
                    </h2>
                {/if}
            </div> -->
            <div class="flex flex-wrap">
                {#if commonImg}
                    <div
                        class="flex lg:hidden md:w-12/12  flex-wrap px-1 lg:px-4 w-full">
                        <CommonImg img={commonImg} />
                    </div>
                    <Letter {selectedLink}
                        {subTopic}
                        language={language1}
                        data={data1[subTopic.value]} />
                    <div
                        class="hidden lg:flex md:w-8/12 lg:w-4/12 flex-wrap px-1 lg:px-4 w-full">
                        <CommonImg img={commonImg} />
                    </div>
                    <Letter {selectedLink}
                        {subTopic}
                        language={language2}
                        data={data2[subTopic.value]} />
                {:else if data1[subTopic.value] && data2[subTopic.value]}
                    <Letter {selectedLink}
                        additionalClasses="md:w-6/12"
                        {subTopic}
                        withImg="true"
                        language={language1}
                        data={data1[subTopic.value]} />
                    <Letter {selectedLink}
                        additionalClasses="md:w-6/12"
                        withImg="true"
                        {subTopic}
                        language={language2}
                        data={data2[subTopic.value]} />
                {:else if data1[subTopic.value]}
                    <Letter {selectedLink}
                        additionalClasses="md:w-12/12"
                        withImg="true"
                        {subTopic}
                        language={language1}
                        data={data1[subTopic.value]} />
                {:else if data2 && data2[subTopic.value]}
                    <Letter {selectedLink}
                        additionalClasses="md:w-12/12"
                        withImg="true"
                        {subTopic}
                        language={language2}
                        data={data2[subTopic.value]} />
                {/if}
            </div>
        {:else if $letterData && (!language1 || !language2)}
            <div class="text-center items-center flex flex-col">
                <h2 class="text-xl text-gray-700">
                    {$_('l_display.select_languages')}
                </h2>
                <ul class="list-none items-center">
                    <LanguageSelect />
                </ul>
            </div>
        {/if}
        {#if $loadingData}
            <div class="self-center flex">
                <RingLoader size="60" color="#DB2777" unit="px" />
                <h3 class="text-xl text-gray-700 self-center">
                    {$_('l_display.loading')}
                </h3>
            </div>
        {/if}
    </div>
</div>